import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useCWPContext from '../context/useCWPContext';

export default function CwpMultipleModal() {
  const { rowsSelected, cwpDetailsMultiple, setCwpDetailsMultiple, handleMultipleApproval } =
    useContext(useCWPContext);

  const columns = [
    { field: 'requested_by', flex: 1, headerName: 'Requested By', width: 200 },
    { field: 'manager_name', flex: 1, headerName: 'Manager Name', width: 200 },
    { field: 'md_name', flex: 1, headerName: 'MD Name', width: 200 },
    { field: 'date_scheduled', flex: 1, headerName: 'Date Appointment', width: 200 },
  ];
  const handleClose = () => {
    setCwpDetailsMultiple({
      ...cwpDetailsMultiple,
      toggle: false,
      cwpDetMul: [],
      approval_status: '',
    });
  };
  return (
    <Dialog
      open={cwpDetailsMultiple.toggle}
      onClose={handleClose}
      maxWidth='lg'
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '100%',
        },
      }}
    >
      <DialogTitle>Request Summary</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid xs={12} sm={12} md={12}>
            <h2>
              <small>
                You are about to {cwpDetailsMultiple.approval_status} {rowsSelected.length} request
                and {cwpDetailsMultiple.cwpDetMul.length}
                {} appointment selected proceed?
              </small>
            </h2>
          </Grid>
          <Grid xs={12} sm={12} md={12}>
            <DataGridPro
              rows={cwpDetailsMultiple.cwpDetMul}
              columns={columns}
              loading={cwpDetailsMultiple.loading}
              autoHeight
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='success'
          onClick={() => {
            let statusCode;
            const status = cwpDetailsMultiple.approval_status;

            if (status === 'Approve') {
              statusCode = 1;
            } else if (status === 'Recover') {
              statusCode = 0;
            } else if (status === 'Reject') {
              statusCode = 3;
            } else {
              statusCode = 0;
            }
            const approvalCode = statusCode;
            handleMultipleApproval(approvalCode);
          }}
        >
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
